enum Routes {
    Build = '/',
    Inspire = '/inspire',
    Library = '/library',
}

export default Routes;